import { useMemo, useState } from "react";
import "./ParentGate.css";

interface ParentGateProps {
  title: string;
  onConfirm: () => void;
  onCancel: () => void;
}

function pickPrompt(): { target: number; options: number[] } {
  const target = Math.floor(Math.random() * 8) + 2;
  const distractors = new Set<number>();
  while (distractors.size < 3) {
    const n = Math.floor(Math.random() * 9) + 1;
    if (n !== target) distractors.add(n);
  }
  const options = [target, ...distractors].sort(() => Math.random() - 0.5);
  return { target, options };
}

export function ParentGate({ title, onConfirm, onCancel }: ParentGateProps) {
  const prompt = useMemo(() => pickPrompt(), []);
  const [error, setError] = useState(false);

  const handlePick = (n: number) => {
    if (n === prompt.target) onConfirm();
    else setError(true);
  };

  return (
    <div
      className="parent-gate-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="parent-gate">
        <h2 className="parent-gate-title">{title}</h2>
        <p className="parent-gate-subtitle">
          Grown-up check — tap the number <strong>{prompt.target}</strong>
        </p>
        <div className="parent-gate-options">
          {prompt.options.map((n) => (
            <button
              key={n}
              type="button"
              className="parent-gate-option"
              onClick={() => handlePick(n)}
            >
              {n}
            </button>
          ))}
        </div>
        {error && <p className="parent-gate-error">Not quite — try again.</p>}
        <button type="button" className="parent-gate-cancel" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}
